var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.293 1.707 12 12 1.414-1.414-5.292-5.292 5.292-5.292L12.293.295 7 5.587 1.707.293.293 1.707ZM5.707 9.707l-4 4-1.414-1.414 4-4 1.414 1.414Z",
    fill: "currentColor"
  })));
};

export { SvgX as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTQgMTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0wLjI5Mjk2OSAxLjcwNzE4TDEyLjI5MyAxMy43MDcyTDEzLjcwNzIgMTIuMjkzTDguNDE1MzYgNy4wMDExNUwxMy43MDcgMS43MDkyTDEyLjI5MjggMC4yOTQ5NDJMNy4wMDExNSA1LjU4Njk0TDEuNzA3MTggMC4yOTI5NjlMMC4yOTI5NjkgMS43MDcxOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8cGF0aCBkPSJNNS43MDcxOCA5LjcwNzE4TDEuNzA3MTggMTMuNzA3MkwwLjI5Mjk2OSAxMi4yOTNMNC4yOTI5NyA4LjI5Mjk3TDUuNzA3MTggOS43MDcxOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";